import type { StoryblokBlock } from '@cinch-nx/data-storyblok'

import HowToGetCinchCharge from '../cinch-charge/how-to-get-cinchcharge/how-to-get-cinchcharge'
import Aftercare from '../cinch-shield/aftercare/aftercare'
import { Lifeshine } from '../cinch-shield/lifeshine/lifeshine'
import PeaceOfMind from '../cinch-shield/peace-of-mind/peace-of-mind'
import DownloadApp from '../download-app/download-app'
import FaqAccordion from '../faq-accordion/faq-accordion'
import FeatureIconCardSection from '../feature-icon-card-section/feature-icon-card-section'
import FeatureImageCardSection from '../feature-image-card-section/feature-image-card-section'
import { FeaturedEVsCarousel } from '../featured-evs-carousel/featured-evs-carousel'
import FinanceExample from '../finance-example/finance-example'
import Hero from '../hero/hero'
import { TextInlineImageSection } from '../text-inline-image-section/text-inline-image-section'
import { Text } from '../text/text'
import { CtaButton } from '../cta-button/cta-button'
import TrustPilotQuote from '../trustpilot-quote/trustpilot-quote'
import VerticalStepsSection from '../vertical-steps-section/vertical-steps-section'
import type { ComponentMap } from './types'
import { ElementFactory, checkNotOverLimit } from './util'
import { RichTextSection } from '@cinch-nx/landing-ui-shared'
import { globalStoryblokComponents } from '@cinch-nx/storyblok'
import { SectionTitle } from '../section-title/section-title'

const components: ComponentMap = {
  GenericHero: Hero,
  VapsText: Text,
  VapsCtaButton: CtaButton,
  Aftercare: Aftercare,
  Lifeshine: Lifeshine,
  FeatureImageCardSection: FeatureImageCardSection,
  PeaceOfMind: PeaceOfMind,
  VapsTrustPilotQuote: TrustPilotQuote,
  VapsFaqSection: FaqAccordion,
  TextInlineImageSection: TextInlineImageSection,
  FeatureIconCardSection: FeatureIconCardSection,
  VerticalStepsSection: VerticalStepsSection,
  DownloadApp: DownloadApp,
  FinanceExample: FinanceExample,
  FeaturedEVsCarousel: FeaturedEVsCarousel,
  HowToGetCinchCharge: HowToGetCinchCharge,
  RichTextSection: RichTextSection,
  SectionTitle,
  ...globalStoryblokComponents,
}

export interface StoryblokRendererProps {
  block: StoryblokBlock<unknown> | StoryblokBlock<unknown>[]
  props?: { [key: string]: unknown }
  componentsWithWrapper?: string[]
  limitedItems?: { [key: string]: number }
}

export function StoryblokRenderer({
  block,
  props,
  componentsWithWrapper,
  limitedItems,
}: StoryblokRendererProps) {
  if (Array.isArray(block)) {
    return (
      <>
        {block.map((blockElement) =>
          checkNotOverLimit(blockElement, limitedItems)
            ? ElementFactory(
                blockElement,
                components,
                props,
                componentsWithWrapper,
              )
            : null,
        )}
      </>
    )
  }

  return <>{ElementFactory(block, components)}</>
}

export default StoryblokRenderer
